<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Lote: {{lot.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/lotes/nuevo">Nuevo</b-button>
                        <b-button variant="outline-primary" :to="'/lotes/editar/' + this.$route.params.id">Editar</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Nombre:</b><span>{{lot.title}}</span></b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <br>
                        <h3 class="h4">Multimedia</h3>
                    </b-col>
                    <b-col md="6">
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item" :src="lot.video" frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <b-table hover v-bind:items="lot.images" v-bind:fields="imageHeaders" outlined
                                 head-variant="light">
                            <template slot="image" slot-scope="data">
                                <a :href="data.item.url" target="_blank"><img class="thumb" :src="data.item.url"/></a>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "LotsView",
        data() {
            return {
                isLoading: true,
                imageHeaders: [
                    {key: 'image', label: 'Imagen', sortable: false},
                    {key: 'url', label: 'Ruta de archivo', sortable: true}
                ]
            }
        },
        computed: {
            ...mapGetters({
                lot: 'lots/getEntries',
            })
        },
        created() {
            this.isLoading = false;

            this.$store.dispatch('lots/loadEntries', this.$route.params.id).then(() => {
                this.isLoading = false;
            });
        }
    }
</script>

<style scoped>
    .list-group-item > b {
        flex: 2;
    }

    .thumb {
        max-width: 128px;
    }
</style>